/***
*
*   FOOTER (homepage)
*   Static homepage footer
*
**********/

import React from 'react';
import { Animate, Row, Content, Link } from 'components/lib'
import Style from './footer.tailwind.js';

export function Footer(props){

  return (
    <Animate type='slideup'>
      <footer className={ Style.footer }>
        <Row>
          <Content>

            <nav className={ Style.nav }>
              <Link url='/' text='Inicio' className={ Style.link } color='dark'/>
              {/* <Link url='/pricing' text='Pricing' className={ Style.link } color='dark' /> */}
              <Link url='/' text='Iniciar sesión' className={ Style.link } color='dark' />
              {/* <Link url='/signup' text='Sign up' className={ Style.link } color='dark' /> */}
              <Link url='/terms' text='Términos & Condiciones' className={ Style.link } color='dark' />
              <Link url='/privacy' text='Políticas de privacidad' className={ Style.link } color='dark' />
              <Link url='/contact' text='Contactanos' className={ Style.link } color='dark' />
            </nav>

            <div className={ Style.copyright }>{ `Copyright © Alpha Core Solutions ${new Date().getFullYear()}`}</div>
            <address className={ Style.address }>Riobamba - Ecuador</address>

          </Content>
        </Row>
      </footer>
    </Animate>
  );
}